export default "__VITE_ASSET__mQwXdsle__"